export const iconFontAwesomeCommunicationMobileScreen = (
	<i className="fa-solid fa-mobile-screen"></i>
);
